import React from 'react';

import DataContainer from './DataContainer';
import { DataDetail } from './DataDetail';

const DataPage: React.FC = () => (
    <DataContainer.Provider>
        <DataDetail/>
    </DataContainer.Provider>
);
export default DataPage;
